<template>
  <el-dialog
    title="複製音檔-選擇目的資料夾"
    fullscreen
    @close="handleDlgClose"
    :visible.sync="innerVisible"
  >
    <div class="container">
      <el-form
        ref="queryForm"
        :model="queryForm"
        label-width="50px"
        :inline="true"
        @keyup.enter.native="handleQueryClick(queryForm)"  @submit.native.prevent
      >
        <div class="row justify-content-between">
          <div class="px-2">
            <el-form-item label="頻道" label-width="50px">
              <el-select
                size="small"
                v-model="queryForm.chnl"
                class="selectqry"
              >
                <el-option
                  v-for="item in myChnls"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                 <el-tooltip v-if="item.isSystem" content="系統頻道，勿公開、勿分享">
                <i class="el-icon-setting">{{ item.name }}</i>
               </el-tooltip>
                <span v-else
                  >{{ item.name }}</span>
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="關鍵字" label-width="60px">
              <el-input
                v-model="queryForm.qstr"
                placeholder="名稱"
                size="small"
                style="width:90px"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button
                type="primary"
                @click="handleQueryClick(queryForm)"
                size="small"
                >查詢</el-button
              >
            </el-form-item>
          </div>
          <div class="funcpanel">
            <el-button
              size="small"
              type="primary"
              icon="el-icon-top"
              @click="gotoFolder(null)"
              :disabled="!canGoUpFolder()"
              >回上一層</el-button
            >
          </div>
        </div>

        <div class="row">
          <el-form-item label="檔案同名時：" label-width="125px" class="my-0 py-0">
            <el-radio
              v-model="fileDuplicateOption"
              label="replace"
              class="radioItem"
              >取代</el-radio
            >
            <el-radio
              v-model="fileDuplicateOption"
              label="skip"
              class="radioItem"
              >忽略</el-radio
            >
          </el-form-item>
        </div>

        <div class="row mt-1">
          <el-form-item label="資料夾同名時：" label-width="135px" class="my-0 py-0">
            <el-radio
              v-model="folderDuplicateOption"
              label="replace"
              class="radioItem"
              >取代</el-radio
            >
            <el-radio
              v-model="folderDuplicateOption"
              label="skip"
              class="radioItem"
              >忽略</el-radio
            >
            <el-radio
              v-model="folderDuplicateOption"
              label="merge"
              class="radioItem"
              >合併</el-radio
            >
          </el-form-item>
        </div>

      </el-form>
    </div>

    <CCard>
      <CCardHeader class="py-0">
        <CRow>
          <div class="container" style="margin:0">
            <div class="row ">
              <div class="headerpanel">
                <CIcon name="cib-apple-podcasts" class="headericon" />
              </div>

              <div class="ml-4">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item
                    v-for="(node, idx) in folderTree"
                    :key="`node_{${node.assetId}}`"
                  >
                    <el-button
                      type="text"
                      :disabled="isLeafNode(idx)"
                      @click="handleNodeClk(idx)"
                      >{{ node.assetName }}
                      <span v-if="node.isChannel && node.isPublic">(公開)</span>
                      <span v-if="node.isChannel && !node.isPublic"
                        >(非公開)</span
                      >
                      <i v-if="node.assetIsEncrypt" class="el-icon-lock"></i>
                    </el-button>
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </div>
          </div>
        </CRow>
      </CCardHeader>
      <CCardBody>
        <CRow>
          <el-table
          :border="true"
            ref="dataTable"
            v-loading="isLoading"
            :data="assets"
            highlight-current-row
            @sort-change="sortChange"
            @current-change="handleCurrentChange"
            :default-sort="{ prop: 'startDate', order: 'descending' }"
            stripe
            @row-dblclick="handleRowDbClk"
            @selection-change="handleSelectionChange"
            style="width: 100%"
          >
            <!--<el-table-column type="selection" width="45" :selectable="rowSelectable"> </el-table-column>-->

            <el-table-column type="index" :index="indexFormatter" fixed>
            </el-table-column>

            <el-table-column label="名稱" prop="name" sortable="custom">
              <template #default="scope">
                <img
                  v-if="!scope.row.isLeaf"
                  src="../../assets/icons/folder.svg"
                  class="foldericon"
                />
                <img
                  v-else
                  src="../../assets/icons/file.svg"
                  class="fileicon"
                />
                <!--<i v-if="!scope.row.isLeaf" class="el-icon-folder"></i>-->
                <!--<i v-else class="el-icon-document"></i>-->

                <span class="ml-3">
                  {{ scope.row.name }}
                </span>
                <el-popover
                  v-if="scope.row.isEncrypt"
                  title="失效日"
                  width="200"
                  trigger="hover"
                >
                  <span v-if="scope.row.encryptExpiredMode == 'absolute'">
                    {{ convertTime(new Date(parseInt(scope.row.endDate))) }}
                  </span>
                  <span v-else
                    >下載後 {{ scope.row.endDateAmount }}
                    {{ formatDateUnit(scope.row.endDateUnit) }}</span
                  >

                  <i slot="reference" class="el-icon-lock"></i>
                </el-popover>
              </template>
            </el-table-column>

            <!--<el-table-column-->
            <!--label="上次修改時間"-->
            <!--prop="lastUpdateDate"-->
            <!--sortable="custom"-->
            <!--width="200" >-->

            <!--<template #default="scope">-->
            <!--{{ convertTime(scope.row.lastUpdateDate) }}-->
            <!--</template>-->
            <!--</el-table-column>-->

            <!--<el-table-column label="大小" prop="size" width="100">-->
            <!--<template #default="scope">-->
            <!--<div v-if="scope.row.isLeaf">-->
            <!--{{ getReadableSize(scope.row.size) }}-->
            <!--</div>-->
            <!--[><div v-else-if="scope.row.size !== null"><]-->
            <!--<div v-else-if="scope.row.size !== null" style="word-break: keep-all">-->
            <!--{{ scope.row.size }}-->
            <!--</div>-->
            <!--<div v-else>-->
            <!--<img-->
            <!--src="../../assets/icons/info.svg"-->
            <!--class="infoicon"-->
            <!--@click="getFolderSize(scope.row, scope.$index)" />-->
            <!--</div>-->
            <!--</template>-->
            <!--</el-table-column>-->

            <!--<el-table-column label="操作">-->
            <!--<template #default="scope">-->
            <!--<el-button-->
            <!--size="mini"-->
            <!--@click="editAssetName(scope.row)"-->
            <!--:disabled="isExtChnl || rowIsReadOnly(scope.row)" >重新命名-->
            <!--</el-button>-->
            <!--<el-button-->
            <!--type="danger"-->
            <!--size="mini"-->
            <!--@click="delAsset(scope.row.id)"-->
            <!--:disabled="isExtChnl || rowIsReadOnly(scope.row)" >刪除-->
            <!--</el-button>-->

            <!--<el-tooltip content="下載" ><el-button-->
            <!--size="mini"-->
            <!--icon="el-icon-download"-->
            <!--@click="downloadAsset(scope.row)" ></el-button ></el-tooltip>-->

            <!--[><el-button<]-->
            <!--[>v-if="enableAssign && !isGlobalChnlMgmt()"<]-->
            <!--[>size="mini"<]-->
            <!--[>@click="grantAsset(scope.row)" >個人授權<]-->
            <!--[></el-button><]-->

            <!--<el-button-->
            <!--v-if="isAssetPlayable(scope.row)"-->
            <!--size="mini"-->
            <!--@click="playAsset(scope.row)" >播放-->
            <!--</el-button>-->

            <!--</template>-->
            <!--</el-table-column>-->
          </el-table>
        </CRow>
      </CCardBody>
    </CCard>

    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">關閉</el-button>
      <el-button type="primary" @click="handleCopy" :disabled="!currentRow"
        >複製至這裡</el-button
      >
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import appConfig from "@/appConfig";
import tagColorsMixin from "@/components/mixin/tagColors.js";
import moment from "moment-timezone";
import API from "@/api/";
export default {
  name: "orgChnlList",
  mixins: [tagColorsMixin],
  model: {
    prop: "visible",
    event: "toggleVisible",
  },

  created() {
    if (this.innerVisible) {
      this.$store.commit("asset/CLEAR");

      if (this.srcFolderTree?.length) {
        this.folderTree = this.srcFolderTree;
      }
      API.my.channels().then(res => {
        this.myChnls = res.data.filter(item => item.parent === null);

        if(!this.myChnls.length) {
          return;
        }

        if (this.channelId) {
          const srcChnl = this.myChnls.find(item => item.id === this.channelId);
          if (!srcChnl) {
            this.queryForm.chnl = this.myChnls[0].id;
            this.activeQueryForm.chnl = this.myChnls[0].id;
            throw new Error("Active Source Channel cannot be found");
          }
          this.queryForm.chnl = this.channelId;
          this.activeQueryForm.chnl = this.channelId;
        }
        else {
          this.queryForm.chnl = this.myChnls[0].id;
          this.activeQueryForm.chnl = this.myChnls[0].id;
        }
        if (this.srcFolderTree?.length) {
          const idx = this.folderTree.length - 1;
          this.gotoFolder(idx);
        }
        else {
          this.getChannelAsset();
        }
      });
    }
  },

  props: {
    visible: {
      type: Boolean,
    },
    assetIds: {
      type: Array,
    },
    channelId: {
      type: Number,
      default: undefined,
    },
    srcFolderTree: {
      type: Array,
      default: function () {return [];},
    },
  },

  data() {
    return {
      isPublic: true,
      selectAssetIds: [],
      enableAssign: false,
      selectedRow: [],
      selectedItemId: null,
      isLoading: false,
      parentId: null,
      isSelectedFolder: false,
      selChnlName: "",
      selAssetName: "",
      folderTree: [],
      myChnls: [],
      //dlgKey: 0,
      //playDlgKey: 0,
      //grantDlgKey: 0,
      //uploadDlgKey: 0,
      //exportDlgKey: 0,
      //isDlgVisible: false,
      //isPlayDlgVisible: false,
      //isGrantDlgVisible: false,
      //isExportDlgVisible: false,
      //isEdtChnlAdmDlgVisible: false,
      //isUploadDlgVisible: false,
      //isSetEncryptDlgVisible: false,
      currentRow: null,
      pageSize: 10,
      fileDuplicateOption: "replace",
      folderDuplicateOption: "replace",
      queryForm: {
        qstr: "",
        chnl: undefined,
      },
      activeQueryForm: {
        qstr: "",
        chnl: undefined,
      },
    };
  },
  methods: {
    handleCopy() {
      const params = {
        assets: this.assetIds,
        destination: this.currentRow.id,
        fileDuplicateOption: this.fileDuplicateOption,
        folderDuplicateOption: this.folderDuplicateOption,
      };
      this.isLoading = true;
      API.asset
        .copyAsset(params)
        .then(() => {
          this.$message({
            type: "success",
            message: "複製成功!",
          });
        })
        .finally(() => {
          this.isLoading = false;
          this.innerVisible = false;
        });
    },
    handleCurrentChange(val) {
      this.currentRow = val;
    },
    getFolderSize(asset, idx) {
      this.isLoading = true;
      API.asset
        .getAssetSize(asset.id)
        .then(res => {
          const { size, count } = res.data;
          console.log(`getFolderSize: size = ${size}, count = ${count}`);

          const newAsset = { ...asset };
          newAsset.size = `${this.getReadableSize(size)}/ ${count}個檔案`;

          const payload = {
            newElem: newAsset,
            index: idx,
          };
          this.$store.commit("asset/CHANGE_ELEMENT", payload);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    getReadableSize(bytes, decimals = 2) {
      if (bytes == 0) return "0 Byte";
      var base = 1024,
        sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        i = Math.floor(Math.log(bytes) / Math.log(base));
      return (
        parseFloat((bytes / Math.pow(base, i)).toFixed(decimals)) +
        " " +
        sizes[i]
      );
    },
    rowSelectable(row) {
      return row.source == 0;
    },
    rowIsReadOnly(row) {
      return row.source != 0;
    },
    exportAssets() {
      this.exportDlgKey = this.exportDlgKey ? 0 : 1;
      this.isExportDlgVisible = true;
    },

    isFilePlayable(fileName) {
      const playableExt = appConfig.PLAYABLE_EXT;
      const ext =
        fileName.indexOf(".") > -1
          ? fileName
              .split(".")
              .pop()
              .toLowerCase()
          : "";
      return playableExt.some(item => item === ext);
    },
    isAssetPlayable(item) {
      if (!item.isLeaf) {
        return false;
      } else {
        return this.isFilePlayable(item.name);
      }
    },
    isGlobalChnlMgmt() {
      return this.myownOrg === appConfig.SYS_ORG_NAME ? true : false;
    },
    handleSelectionChange(rows) {
      //console.log(`handleSelectionChange: val = ${JSON.stringify(rows)}`);
      this.selectedRow = rows;
    },
    formatDateUnit(unit) {
      switch (unit) {
        case "years":
          return "年";
        case "months":
          return "月";
        case "days":
          return "日";
      }
    },
    convertTime(tm) {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return moment(tm)
        .tz(tz)
        .format("YYYY-MM-DD hh:mm:ss A");
    },
    isLeafNode(idx) {
      return idx === this.folderTree.length - 1 ? true : false;
    },
    handleNodeClk(idx) {
      this.gotoFolder(idx);
    },
    canGoUpFolder() {
      const idx = this.folderTree.length - 2;
      return idx >= 0 ? true : false;
    },
    //NOTE: if idx is null, go 1 level folder up
    gotoFolder(idx) {
      if (idx == null) {
        idx = this.folderTree.length - 2;
      }
      if (idx >= 0) {
        //console.log(`gotoFolder: folderTree = ${JSON.stringify(this.folderTree)}`)

        const target = this.folderTree[idx];
        //console.log(`gotoFolder: target = ${JSON.stringify(target)}`)
        const removeNodes = this.folderTree.splice(idx + 1);
        this.$store.commit("asset/setParentIsEncrypt", target.isEncrypt);
        this.$store.commit("asset/setParentSource", target.source);
        //const curNode = this.folderTree.pop();
        this.getAssetContent(this.sort, this.order, {
          parent: target.assetId,
        }).catch(() => {
          this.folderTree = this.folderTree.concat(removeNodes);
          //this.folderTree.push(curNode);
        });
      }
    },
    getChnlName(chnlId) {
      const foundChnl = this.myChnls.find(chnl => chnl.id === chnlId);
      return foundChnl ? foundChnl.name : "";
    },
    getChnlEnableAssign(chnlId) {
      const foundChnl = this.myChnls.find(chnl => chnl.id === chnlId);
      return foundChnl ? foundChnl.enableAssign : false;
    },
    getChnlIsPublic(chnlId) {
      const foundChnl = this.myChnls.find(chnl => chnl.id === chnlId);
      return foundChnl.isPublic;
    },
    handleRowDbClk(row) {
      //console.log(`handleRowDbClk: row = ${JSON.stringify(row)}`);
      //console.log(`handleRowDbClk: column = ${JSON.stringify(column)}`);

      //@todo: ignore button clicked

      if (!row.isLeaf) {
        this.$store.commit("asset/setParentIsEncrypt", row.isEncrypt);
        this.$store.commit("asset/setParentSource", row.source);
        this.folderTree.push({
          assetId: row.id,
          assetName: row.name,
          assetIsEncrypt: row.isEncrypt,
          source: row.source,
        });
        this.getAssetContent(this.sort, this.order, { parent: row.id }).catch(
          () => {
            this.folderTree.pop();
          }
        );
      }
    },
    uploadItem() {
      this.parentId = this.$store.state.asset.parent;
      this.uploadDlgKey = this.uploadDlgKey ? 0 : 1;
      this.isUploadDlgVisible = true;
    },
    addNewFolder() {
      this.parentId = this.$store.state.asset.parent;
      this.isSelectedFolder = true;
      this.selectedItemId = null;
      this.dlgKey = this.dlgKey ? 0 : 1;
      this.isDlgVisible = true;
    },

    batchGrantAssets() {
      const assetIds = this.selectedRow.map(row => row.id);
      this.selectAssetIds = assetIds;
      this.selAssetName = "(多個檔案)";
      this.selChnlName = this.getChnlName(this.activeQueryForm.chnl);
      this.grantDlgKey = this.grantDlgKey ? 0 : 1;
      this.isGrantDlgVisible = true;
      this.$refs.dataTable.clearSelection();
    },

    grantAsset(item) {
      this.selectAssetIds = [item.id];
      this.selAssetName = item.name;
      this.selChnlName = this.getChnlName(this.activeQueryForm.chnl);
      this.grantDlgKey = this.grantDlgKey ? 0 : 1;
      this.isGrantDlgVisible = true;
    },
    playAsset(item) {
      this.selectedItemId = item.id;
      this.selAssetName = item.name;
      this.playDlgKey = this.playDlgKey ? 0 : 1;
      this.isPlayDlgVisible = true;
    },
    editAssetName(item) {
      this.selectedItemId = item.id;
      this.isSelectedFolder = !item.isLeaf;
      this.dlgKey = this.dlgKey ? 0 : 1;
      this.isDlgVisible = true;
    },
    setEncrypt() {
      this.isSetEncryptDlgVisible = true;
    },
    handleQueryClick(queryForm) {
      const queryNewChnl = queryForm.chnl !== this.activeQueryForm.chnl;
      this.activeQueryForm = { ...queryForm };
      if (queryNewChnl) {
        this.getChannelAsset(queryForm);
      } else {
        const newParams = { ...queryForm };
        delete newParams.chnl;
        this.getAssetContent(this.sort, this.order, newParams);
      }
    },

    //NOTE: params is used to assign qstr; channelId is given by activeQueryForm.chnl
    getChannelAsset(params = {}) {
      this.folderTree = [];
      const chnlName = this.getChnlName(this.activeQueryForm.chnl);
      this.enableAssign = this.getChnlEnableAssign(this.activeQueryForm.chnl);
      this.isPublic = this.getChnlIsPublic(this.activeQueryForm.chnl);
      this.isLoading = true;
      this.$store
        .dispatch("asset/getChannelMusicAsset", {
          channelId: this.activeQueryForm.chnl,
          sort: this.sort,
          order: this.order,
          ...params,
        })
        .then(res => {
          this.folderTree.push({
            assetId: this.$store.state.asset.parent,
            assetName: chnlName,
            isChannel: true,
            isPublic: this.isPublic,
            source: 0,
          });
          //console.log(`getChannelAsset then: folderTree = ${JSON.stringify(this.folderTree)}`)
          return res;
        })
        .catch(err => {
          console.log(`getChannelAsset err = ${err}`);
          this.folderTree.push({ assetId: null, assetName: chnlName });
          //console.log(`getChannelAsset catch: folderTree = ${JSON.stringify(this.folderTree)}`)
          return err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    //NOTE: if parent is assigned in params, it will get content for another asset;
    //    Otherwise, it will just query for the current parent asset
    getAssetContent(sort, order, params = {}) {
      this.isLoading = true;
      return this.$store
        .dispatch("asset/getAssetContent", {
          sort,
          order,
          ...params,
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    indexFormatter(index) {
      return `#${index + 1}`;
    },
    delSelectedItems() {
      this.$confirm("此操作將永久刪除選取的項目, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.isLoading = true;
        const promises = this.selectedRow.map(row => API.asset.remove(row.id));
        Promise.all(promises).finally(() => {
          this.isLoading = false;
          this.getAssetContent(this.sort, this.order, this.activeQueryForm);
        });
      });
    },
    downloadAsset(item) {
      const baseURL = process.env.VUE_APP_APIURL
        ? process.env.VUE_APP_APIURL
        : window.location.origin.replace("//admin.", "//api.") + "/";
      let finalUrl = `${baseURL}asset2/download/${item.id}?token=${encodeURI(
        this.$store.state.auth.access_token
      )}`;
      const link = document.createElement("a");
      document.body.appendChild(link);
      link.href = finalUrl;
      link.setAttribute("type", "hidden");
      link.click();
    },
    delAsset(itemId) {
      this.$confirm("此操作將永久刪除該項目, 是否繼續?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          API.asset.remove(itemId).then(() => {
            this.getAssetContent(this.sort, this.order, this.activeQueryForm);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
          });
        })
        .catch(() => {
          /*this.$message({*/
          /*type: 'info',*/
          /*message: '已取消删除'*/
          /*});          */
        });
    },
    sortChange(args) {
      if (args.order === null) {
        this.$store.commit("asset/SET_SORT", "id");
        this.$store.commit("asset/SET_ORDER", "ascending");
      } else {
        this.$store.commit("asset/SET_SORT", args.prop);
        this.$store.commit("asset/SET_ORDER", args.order);
      }
      this.getAssetContent(this.sort, this.order, this.activeQueryForm);
    },
    handleDlgClose() {
      this.$emit("dialogClosed");
    },
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
    anySelectedGrantable() {
      return this.selectedRow.some(() => true);
    },
    isExtChnl() {
      if (this.activeQueryForm.chnl) {
        const foundChnl = this.myChnls.find(
          chnl => chnl.id === this.activeQueryForm.chnl
        );
        return (foundChnl.parent ? true : false) || foundChnl.isReadOnly;
      }
      return false;
    },
    parentSource() {
      return this.$store.state.asset.parentSource;
    },
    assets() {
      return this.$store.state.asset.assets.filter(
        item => item.isLeaf === false
      );
    },
    ...mapGetters({
      parentIsEncrypt: "asset/parentIsEncrypt",
      myownOrg: "auth/orgName",
      total: "asset/total",
      sort: "asset/sort",
      order: "asset/order",
    }),
  },
};
</script>

<style>
.radioItem {
  width: 50px;
}
.foldericon {
  width: 20px;
  height: 20px;
  margin-right: -7px;
}
.fileicon {
  width: 24px;
  height: 24px;
  margin-left: -2px;
  margin-right: -7px;
}
.funcpanel {
  padding-top: 6px;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 1.5rem;
}
.selectqry {
  width: 12rem;
}
</style>
